import * as React from 'react';
import { observer } from 'mobx-react';
import { ChangeHistoryEmployeeCycleView } from 'nomst/Components/ChangeHistory/changeHistoryEmployeeCycleView';
import { ChangeHistoryPromotionRequestDeleteView }
    from 'nomst/Components/ChangeHistory/changeHistoryPromotionRequestView';
import ChangeHistoryWorkflowActivityView from 'nomst/Components/ChangeHistory/changeHistoryWorkflowActivityView';
import { ChangeHistoryContainer } from 'nomst/Stores/ChangeHistory/changeHistoryContainer';
import { ChangeHistoryEmployeeCycle }
    from 'nomst/Stores/ChangeHistory/changeHistoryEmployeeCycle';
import { ChangeHistoryPromotionRequestDelete }
    from 'nomst/Stores/ChangeHistory/changeHistoryPromotionRequestDelete';
import { IChangeHistoryItem } from 'typings/MobxComponents/changeHistoryItem';
import { ChangeHistoryItem } from 'typings/enums';
import { CurrencyConversion } from 'nomst/Stores/Utility/currencyConversion';
import {
    ChangeHistoryWorkflowSubmitOrSendBack
} from 'nomst/Stores/ChangeHistory/changeHistoryWorkflowSubmitOrSendBack';
import { ChangeHistoryWorkflowApprove } from 'nomst/Stores/ChangeHistory/changeHistoryWorkflowApprove';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import { NavigationStore } from 'nomst/Stores/Navigation/navigation.store';
import { formatDate, dateTextFormat } from 'utils/dateUtils';

export interface IChangeHistoryContainerProps {
    configuration: Configuration;
    navigationStore: NavigationStore;
    changeHistoryContainer: ChangeHistoryContainer;
    selectedCurrency: Nullable<string>;
}

export class ChangeHistoryContainerView extends React.Component<IChangeHistoryContainerProps> {
    render(): React.ReactNode {
        const { changeHistoryContainer } = this.props;

        return (
            <div className="history-block">
                <h3>{this.getContainerDate(changeHistoryContainer.timestamp)}</h3>
                <div className="history-block-list">
                    {changeHistoryContainer.items
                        .map((changeHistoryItem: IChangeHistoryItem, index: number) =>
                            this.renderChangeHistoryItem(changeHistoryItem, index, changeHistoryItem.timestamp ?? ''))}
                </div>
            </div>
        );
    }

    private renderChangeHistoryItem(
        changeHistoryEntry: IChangeHistoryItem,
        index: number,
        timestamp: string): React.ReactNode {
        const { configuration, navigationStore } = this.props;
        switch (changeHistoryEntry.code) {
            case ChangeHistoryItem.ChangeHistoryEmployeeCycle:
                return (
                    <ChangeHistoryEmployeeCycleView
                        configuration={configuration}
                        navigationStore={navigationStore}
                        key={index}
                        changeHistoryEmployeeCycle={new ChangeHistoryEmployeeCycle(
                            changeHistoryEntry,
                            configuration,
                            new CurrencyConversion(configuration.currencies))}
                        selectedCurrency={this.props.selectedCurrency}
                        timestamp={timestamp}
                    />
                );
            case ChangeHistoryItem.ChangeHistoryPromotionRequestDelete:
                return (
                    <ChangeHistoryPromotionRequestDeleteView
                        configuration={configuration}
                        navigationStore={navigationStore}
                        key={index}
                        changeHistoryPromotionRequestDelete={new ChangeHistoryPromotionRequestDelete(
                            changeHistoryEntry)}
                        timestamp={timestamp}
                    />
                );
            case ChangeHistoryItem.ChangeHistoryWorkflowApprove:
                return (
                    <ChangeHistoryWorkflowActivityView
                        key={index}
                        changeHistoryWorkflowEntry={new ChangeHistoryWorkflowApprove(changeHistoryEntry)}
                        timestamp={timestamp}
                    />
                );
            // tslint:disable-next-line:no-duplicated-branches
            case ChangeHistoryItem.ChangeHistoryWorkflowSendBack:
                return (
                    <ChangeHistoryWorkflowActivityView
                        key={index}
                        changeHistoryWorkflowEntry={new ChangeHistoryWorkflowSubmitOrSendBack(changeHistoryEntry)}
                        timestamp={timestamp}
                    />
                );
            // tslint:disable-next-line:no-duplicated-branches
            case ChangeHistoryItem.ChangeHistoryWorkflowSubmit:
                return (
                    <ChangeHistoryWorkflowActivityView
                        key={index}
                        changeHistoryWorkflowEntry={new ChangeHistoryWorkflowSubmitOrSendBack(changeHistoryEntry)}
                        timestamp={timestamp}
                    />
                );
        }

        return null;
    }

    private getContainerDate(historyTimestampUtc: string ): string {
        const currentDateLocal = new Date();

        const historyDate = new Date(historyTimestampUtc);
        if (historyTimestampUtc.endsWith('Z')) {
            historyDate.setMinutes(historyDate.getMinutes() + historyDate.getTimezoneOffset());
        }

        // take only the date into account and clear out the time
        // as it messes up the milliseconds calculation
        currentDateLocal.setHours(0, 0, 0, 0);
        historyDate.setHours(0, 0, 0, 0);

        const oneDay = 24 * 60 * 60 * 1000;
        const timeDifferenceinMilliSec = currentDateLocal.getTime() - historyDate.getTime() ;
        const dayDifference = Math.round(timeDifferenceinMilliSec / oneDay);

        if (dayDifference === 0) {
            return 'Today';
        }

        if (dayDifference === 1) {
            return 'Yesterday';
        }

        return formatDate(historyDate, dateTextFormat);
    }
}

export default (observer(ChangeHistoryContainerView));